const wrapper = "_uxswiv7v59";
const contextMenu = "_uxsc5k7c4p";

export { contextMenu, wrapper };
import "./spec.23video.audio.style.linaria.module.css";
//# sourceMappingURL=spec.23video.audio.style.js.map
